import React from 'react';

export default class ResizePureComponent extends React.Component {

    componentDidMount() {
        this.onResizeFunc = this.onResize.bind(this);

        window.addEventListener("resize", this.onResizeFunc);
        this.onResize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.onResizeFunc);
    }

    onResize() {
        // eslint-disable-next-line
        console.error('The onResize method has to be overloaded for children of ResizePureComponent');
    }
}
